//import { Service, PAGEACTIVITY } from './../constants/actionType'
import { catchJSException } from './logService';
//import { getPDCforSC } from './apiService'
import { Utils } from '../util/utils';
import { store } from './../index';
var vzdl = require('./vzdlData.json');

export const getVZDLInit = (
  visitID,
  pageName,
  category = '',
  addToCart = '',
  detail,
  eventValue,
  channel = '',
  errorMsg,
  userObj = {},
  txnObj = {},
  eventNumber = '',
  contentFrag = {},
  utilsObj,
) => {
  var contentFragVal = '';
  let vzId = '';
  var userinfo = '';
  var flowName = '';
  var events = '';
  var eventVal = '';
  var intent = '';
  var globalSessionId = store.getState().appVTP && store.getState().appVTP.visitorId ? store.getState().appVTP.visitorId : '';
  var custType = store.getState().appVTP && store.getState().appVTP.mvaType ? store.getState().appVTP.mvaType : '';
  var isMvaFlow = store.getState().appVTP && store.getState().appVTP.isMvaFlow ? store.getState().appVTP.isMvaFlow : false;
  const checkoutVTP = store.getState().checkoutVTP;
  const vzCustType = (checkoutVTP && checkoutVTP.profileInfo?.profileResponse?.userCustomerBusiness) || '';
  let custBusiness = '';
  switch (true) {
    case !!vzCustType:
      custBusiness = vzCustType;
      break;
    case custType === 'vzw':
      custBusiness = 'joint_cust';
      break;
    case custType === 'vzt':
      custBusiness = 'vzt_cust';
      break;
  }
  if (isMvaFlow !== undefined && isMvaFlow === true) {
    intent = 'order';
  } else {
    intent = 'Accessories';
  }
  if (document.cookie && document.cookie.split(';').length > 0) {
    userinfo = document.cookie.split(';').find((val) => val.indexOf('userinfo') !== -1);
    userinfo = userinfo && userinfo.split('userinfo=')[1];
  }

  if (store.getState().checkoutVTP && store.getState().checkoutVTP.profileInfo !== '') {
    let profileResponse =
      store.getState().checkoutVTP.profileInfo.profileResponse &&
      store.getState().checkoutVTP.profileInfo.profileResponse !== undefined &&
      store.getState().checkoutVTP.profileInfo.profileResponse !== ''
        ? store.getState().checkoutVTP.profileInfo.profileResponse
        : '';
    if (profileResponse !== '' && profileResponse !== undefined) {
      vzId = profileResponse.vzId !== null ? profileResponse.vzId : '';
    }
  }
  if (channel === 'Ordering') {
    flowName = 'Ordering';
  } else {
    flowName = 'learn accessory';
  }
  var authStatus = 'anonymous';
  var custRole = '';
  var event10 = '';
  var event117 = '';
  var event116 = '';
  var tenure = '';
  var encryptedAccId = '';
  var accountType = '';
  if (contentFrag && contentFrag.length !== 0) {
    for (var i = 0; i < contentFrag.length; i++) {
      if (i === contentFrag.length - 1) {
        contentFragVal =
          contentFragVal +
          ('L' + (i + 2) + '|' + 'P0' + '|PDP_Compare|' + contentFrag[i].category + '|soiid_|propid_|dispid_82|' + contentFrag[i].productId);
      } else {
        contentFragVal =
          contentFragVal +
          ('L' + (i + 2) + '|' + 'P0' + '|PDP_Compare|' + contentFrag[i].category + '|soiid_|propid_|dispid_82|' + contentFrag[i].productId + '^');
      }
    }
  }
  if (userinfo !== undefined && userinfo !== '') {
    authStatus = 'Logged In';
    custRole = 'accountHolder';
    event10 = 'event10';
    accountType = 'Postpaid';
    /*
        // AccountId fetch
 
        let accId = Utils.getAccountId()
        let accountId = ""    
        if (accId !== undefined && accId !== "") {
            accountId = accId
            encryptedAccId = window.btoa(accountId);
        } else {
            encryptedAccId = ""
        }
 
        // Tenure Calculation
 
        let regDate = Utils.getAccCreationDate()
        var tenure = ""    
        var curDate = new Date()
        var month  =curDate.getMonth() + 1
        var todDate = curDate.getDate()
        var year = curDate.getFullYear()
 
        var currentDate = (month + "/" + todDate + "/" + year).toString()
    
        var date1 = new Date(regDate); 
        var date2 = new Date(currentDate);   
 
        var timeDiff = date2.getTime() - date1.getTime();  
        var daysDiff = timeDiff / (1000 * 3600 * 24);
        tenure = daysDiff.toString()     
        */
  } else {
    authStatus = 'anonymous';
    // tenure = ""
    // encryptedAccId = ""
  }
  let currentTxnArray = {
    name: '',
    id: '',
    merchCat: '',
    category: '',
    offer: '',
    discount: '',
    qty: '',
    recurringPrice: '',
    nonRecurringPrice: '',
    line: '',
    sku: '',
    contractType: '',
    shippingCharge: '',
    shippingType: '',
    shared: '',
  };
  let txnproductArray = [];
  let curProdArray = [];

  let total = '';
  let taxAmt = '';
  let shippingZip = '';
  let shippingCharge = '';
  let paymentType = '';
  let status = '';
  let totalPrice = 0;
  let totalDiscount = 0;
  let orderNo = '';
  let discountId = '';

  if (txnObj.mon !== '' && txnObj.mon !== undefined) {
    orderNo = txnObj.mon;
  }

  if (txnObj.txnData && txnObj.txnData !== '') {
    total = txnObj.txnData.total;
    taxAmt = txnObj.txnData.taxAmt;
    shippingZip = txnObj.txnData.shippingZip;
    shippingCharge = txnObj.txnData.shippingCharge;
    paymentType = txnObj.txnData.paymentType;
    status = txnObj.txnData.status;
  }

  if (txnObj.cartData && txnObj.cartData.length !== 0) {
    txnObj.cartData.map((obj) => {
      curProdArray.push(getCurProdArray(obj));
    });

    // discount & totalPrice calculation

    for (var i = 0; i < txnObj.cartData.length; i++) {
      totalDiscount = (parseFloat(totalDiscount) + parseFloat(txnObj.cartData[i].discount)).toFixed(2);

      //promoId fetch
      if (txnObj.cartData[i].promoId && txnObj.cartData[i].promoId !== null) {
        if (discountId !== '') {
          discountId = discountId + ',' + txnObj.cartData[i].promoId;
        } else {
          discountId = txnObj.cartData[i].promoId;
        }
      }
    }
    for (var i = 0; i < curProdArray.length; i++) {
      totalPrice = (parseFloat(totalPrice) + parseFloat(curProdArray[i].nonRecurringPrice)).toFixed(2);
    }

    if (addToCart === true) {
      if (curProdArray.length === 1) {
        txnproductArray[0] = curProdArray[0];
      } else if (curProdArray.length > 1) {
        for (var i = 0; i < curProdArray.length; i++) {
          if (txnObj.currentlyselected && txnObj.currentlyselected === curProdArray[i].name) {
            txnproductArray[0] = curProdArray[i];
          }
        }
      }
    } else {
      if (channel === 'Ordering') {
        for (var i = 0; i < curProdArray.length; i++) {
          txnproductArray[i] = curProdArray[i];
        }
      } else {
        txnproductArray[0] = curProdArray[0];
      }
    }
  }
  if (eventValue && eventValue === 'scOpen,scAdd') {
    event117 = 'event117';
  }
  if (eventValue && eventValue === 'purchase') {
    event116 = 'event116';
  }
  events =
    event10 +
    (event117 && event10 ? ',' + event117 : event117) +
    (event116 && (event10 || event117) ? ',' + event116 : event116) +
    (eventNumber && (event10 || event116 || event117) ? ',' + eventNumber : eventNumber);
  if (vzId) {
    if (events !== undefined && events !== '') {
      eventVal = 'event9,' + events;
    } else {
      eventVal = 'event9';
    }
  }
  // Custom Event Dispatch
  if (addToCart && addToCart === true) {
    sendCustomEvent('AddtoCart');
  } else if (eventValue && eventValue === 'prodView') {
    sendCustomEvent('Prodview');
  } else if (eventValue && eventValue === 'scRemove') {
    sendCustomEvent('RemovefromCart');
  } else if (eventValue && eventValue === 'cartView') {
    sendCustomEvent('cartView');
  } else if (eventValue && eventValue === 'scCheckout') {
    sendCustomEvent('Checkout');
  } else if (eventValue && eventValue === 'purchase') {
    sendCustomEvent('submitorder');
  } else {
    sendCustomEvent('PageViewOmni');
  }

  try {
    (vzdl.txn.product.current = txnproductArray !== undefined && txnproductArray.length !== 0 ? txnproductArray : currentTxnArray),
      (vzdl.txn.id = orderNo),
      (vzdl.txn.total = total),
      (vzdl.txn.taxAmt = taxAmt.toString()),
      (vzdl.txn.shippingZip = shippingZip),
      (vzdl.txn.shippingTotal = shippingCharge.toString()),
      (vzdl.txn.paymentType = paymentType),
      (vzdl.txn.status = status),
      (vzdl.txn.nonRecurringCharges = totalPrice.toString()),
      (vzdl.txn.discount = totalDiscount.toString()),
      (vzdl.txn.discountId = discountId),
      (vzdl.target.engagement.intent = intent !== undefined && intent !== '' ? intent : ''),
      (vzdl.event.value = eventValue === undefined || eventValue === '' ? '' + eventVal : eventValue + (eventVal ? ',' + eventVal : eventVal)),
      (vzdl.error.code = errorMsg !== undefined || errorMsg !== '' ? errorMsg : ''),
      (vzdl.page.channel = channel !== undefined || channel !== '' ? channel : ''),
      (vzdl.page.channelSession = visitID !== undefined || visitID !== '' ? visitID : ''),
      (vzdl.page.detail = detail !== undefined || detail !== '' ? detail : ''),
      (vzdl.page.displayChannel = 'VZF'),
      (vzdl.page.flow = flowName),
      (vzdl.page.name = !(pageName !== undefined && pageName !== '') ? '' : (pageName === 'keep_previous_page_name') ? vzdl.page.name : pageName),
      (vzdl.page.sourceChannel = 'VZF'),
      (vzdl.page.subFlow = ''),
      (vzdl.page.throttle = ''),
      (vzdl.page.contentFragments = contentFragVal !== undefined && contentFragVal !== '' ? contentFragVal : ''),
      (vzdl.page.link = ''),
      (vzdl.page.LQZip = shippingZip),
      (vzdl.user.existingServices = ''),
      (vzdl.user.account = encryptedAccId),
      (vzdl.user.accountType = accountType),
      (vzdl.user.customerRole = custRole),
      (vzdl.user.customerType = 'Bau'),
      (vzdl.user.authStatus = authStatus),
      (vzdl.user.tenure = tenure !== '' && tenure !== undefined && tenure !== 'NaN' ? tenure : ''),
      // vzdl.user.prospect = (userObj.prospect !== undefined || userObj.prospect !== "") ? userObj.prospect : "",
      (vzdl.user.session = globalSessionId !== undefined && globalSessionId !== '' ? globalSessionId : ''),
      (vzdl.user.chatId = ''),
      (vzdl.user.zip = userObj.zip !== undefined || userObj.zip !== '' ? userObj.zip : ''),
      (vzdl.user.creditAppNum = ''),
      (vzdl.user.productsQualified = ''),
      (vzdl.user.customerBusiness = custBusiness !== undefined && custBusiness !== '' ? custBusiness : ''),
      (vzdl.env.businessUnit = 'Wireline');

    if (userObj.prospect) {
      getSHA256Val(userObj.prospect);
    }
    if (utilsObj && utilsObj.phoneNumber) {
      vzdl.utils.rtm.mtn = utilsObj.phoneNumber;
    }
    if (utilsObj && utilsObj.eMail) {
      vzdl.utils.rtm.prospectEmail = utilsObj.eMail;
    }
    let newEvent = {
      page: vzdl.page,
      event: vzdl.event,
      user: vzdl.user,
      env: vzdl.env,
      error: vzdl.error,
      txn: vzdl.txn,
      target: vzdl.target,
      utils: vzdl.utils,
    };
    window.vzdl = window.vzdl || {};
    window.vzdl = newEvent;
  } catch (ex) {
    catchJSException('vzdl', visitID, 'getVZDLInit', ex);
  }
};

export const getCurProdArray = (obj) => {
  return {
    name: obj.itemName,
    // id: obj.pppId,
    id: obj.partnerPriceId,
    merchCat: '',
    category: obj.categoryName,
    offer: '',
    discount: '',
    qty: obj.qty,
    recurringPrice: '',
    nonRecurringPrice: (obj && obj.qty && obj.price === obj.discountPrice
      ? Math.round(obj.price * obj.qty * 100) / 100
      : Math.round(obj.discountPrice * obj.qty * 100) / 100
    ).toString(),
    line: '',
    sku: obj.skuId,
    contractType: '',
    shippingCharge: '',
    shippingType: '',
    shared: '',
  };
};

var retrySendCustomEventCount = 0;
const sendCustomEvent = (evt) => {
  retrySendCustomEventCount = 0;
  if (window.dtm_doplugins) {
    if (document.createEvent && document.body.dispatchEvent) {
      var event = document.createEvent('Event');
      event.initEvent(evt, true, true);
      document.body.dispatchEvent(event);
    } else if (window.CustomEvent && document.body.dispatchEvent) {
      var ev = new CustomEvent(evt, {
        bubbles: true,
        cancelable: true,
      });
      document.body.dispatchEvent(ev);
    }
  } else {
    setTimeout(() => {
      retrySendCustomEvent(evt);
    }, 500);
  }
};

const retrySendCustomEvent = (evt) => {
  retrySendCustomEventCount = retrySendCustomEventCount++;
  if (window.dtm_doplugins) {
    sendCustomEvent(evt);
  } else if (retrySendCustomEventCount < 5) {
    setTimeout(() => {
      retrySendCustomEvent(evt);
    }, 500);
  }
};

export const scDataDetails = {
  checkoutShipping: { pageName: 'accessories| shipping information', detailPageName: 'accessories| shipping information', events: 'scCheckout' },
  checkoutBilling: { pageName: 'accessories| billing information', detailPageName: 'accessories| billing information', events: 'scCheckout' },
  beginCheckout: { pageName: 'accessories| begin checkout', detailPageName: 'accessories| begin checkout', events: 'event5' },
  viewCart: { pageName: 'accessories| view cart', detailPageName: 'accessories| view cart', events: 'event5,prodView,scView,event22' },
  addToCart: { pageName: 'accessories| pdp| add to cart', detailPageName: 'accessories| pdp| add to cart', events: 'event5,prodView,scAdd,scOpen' },
  orderReview: { pageName: 'accessories| order review', detailPageName: 'accessories| order review', events: 'event46,event5' },
  orderReviewExpress: {
    pageName: 'accessories| order review',
    detailPageName: 'accessories| express| order review',
    events: 'event5,event13,event14,event46,scCheckout',
  },
  orderConfirmation: {
    pageName: 'accessories| order confirmation',
    detailPageName: 'accessories| order confirmation',
    events: 'event5,event40,event42,event43,event44,event55,purchase',
  },
  accessoriesHome: { pageName: 'accessories home', detailPageName: 'accessories| home', events: 'event3' },
  accessoriesCategories: { pageName: 'accessories| categories', detailPageName: 'accessories| categories', events: 'event3' },
  accessoriesPdpCategories: { pageName: 'accessories| pdp', detailPageName: 'accessories| pdp', events: 'event5,event12,prodView' },
  featuredAccessories: { pageName: 'accessories| pdp', detailPageName: 'accessories| pdp', events: 'event5,event12,prodView' },
  othersViewedAccessories: { pageName: 'accessories| pdp', detailPageName: 'accessories| pdp', events: 'event5,event12,prodView' },
};

export const getSHA256Val = async (item) => {
  try {
    const shaKey = `TWoOwIsECMenIFOunDR97WMounTAIns8anD2A3DiaMOndYbUR15dCunderHN0rtHKELop`;
    let hashHex = '';
    const locusID = item + shaKey;
    const msgUint8 = new TextEncoder().encode(locusID);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
    window.vzdl.user.prospect = hashHex;
  } catch (error) {
    console.error('getSHA-256 failed', error);
    catchJSException('vzdl', visitID, 'getSHA256Val', ex);
  }
};

export const updateDetailValue = val => {
  if(val)
  {
      vzdl.page.detail = val;
  }
  else if(!val)
  {
      vzdl.page.detail = '';
  }
}
